"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Generated from cz.marbes.api.objekt.ObjektService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:23:18Z                      #

// ##############################################################

var ObjektApi = function () {
  function ObjektApi() {
    (0, _classCallCheck3.default)(this, ObjektApi);
  }

  (0, _createClass3.default)(ObjektApi, null, [{
    key: "findById",

    /**
     * Vrátí objekt podle id
     *
     * @param id 
     * @return objekt
     */
    value: function findById(id) {
      var uri = serverContextPath + ("/api/objekt/" + id);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Načtení číselníku strana komunikace.
     *
     * @return 
     */

  }, {
    key: "getStranaKomunikace",
    value: function getStranaKomunikace() {
      var uri = serverContextPath + "/api/objekty/stranaKomunikace";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Najde objekty v ext. systémech pomocí fulltextu.
     *
     * @param fulltext 
     * @param obec 
     * @param kodKu 
     * @param typObjektList 
     * @return 
     */

  }, {
    key: "findObjektFulltext",
    value: function findObjektFulltext(fulltext, obec, kodKu, typObjektList) {
      var uri = serverContextPath + "/api/objekt";
      var headers = undefined;
      var params = { fulltext: fulltext, obec: obec, kodKu: kodKu, typObjektList: typObjektList };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vytvoří záznam o objektu v lokální databázi, ale data jsou v externím systému.
     *
     * @param objektResult 
     * @return 
     */

  }, {
    key: "createObjekt",
    value: function createObjekt(objektResult) {
      var uri = serverContextPath + "/api/objekt";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, UpdateMethods.updateObjektSearchResult_0273A3(objektResult), headers));
    }

    /**
     * Vrátí objekty podle jejich id v lokálním systému. Data o objektech jsou získány z externích systémů, nebo lokálních pokud jsou uložena pouze v databázi.
     *
     * @param idObjektList 
     * @return 
     */

  }, {
    key: "findObjektByIds",
    value: function findObjektByIds(idObjektList) {
      var uri = serverContextPath + "/api/objekty/ids";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, idObjektList, headers));
    }

    /**
     * Najde id objektů podle id v ENO.
     *
     * @param enoIds 
     * @return id objektu / id v ENO
     */

  }, {
    key: "findObjektIdByEnoIds",
    value: function findObjektIdByEnoIds(enoIds) {
      var uri = serverContextPath + "/api/objektyId/enoIds";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, enoIds, headers));
    }

    /**
     * Načtení číselníku kvality povrchu.
     *
     * @return 
     */

  }, {
    key: "getKvalitaPovrchu",
    value: function getKvalitaPovrchu() {
      var uri = serverContextPath + "/api/objekty/kvalitaPovrchu";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Načtení číselníku typ komunikace.
     *
     * @return 
     */

  }, {
    key: "getTypKomunikace",
    value: function getTypKomunikace() {
      var uri = serverContextPath + "/api/objekty/typKomunikace";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * smaže lokální údaje o objektu.
     *
     */

  }, {
    key: "deleteObjekt",
    value: function deleteObjekt() {
      var uri = serverContextPath + "/api/objekt/{id}";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.delete(uri, params));
    }

    /**
     * Vytvori objekt v lokální databázi.
     *
     * @param objektResult 
     * @return 
     */

  }, {
    key: "createObjektLocal",
    value: function createObjektLocal(objektResult) {
      var uri = serverContextPath + "/api/objekt/local";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, UpdateMethods.updateAbstractObjekt_5F61A6(objektResult), headers));
    }

    /**
     * Najde zaznam o objektech podle id z katastru.
     *
     * @param idKn 
     * @param typObjekt 
     * @return 
     */

  }, {
    key: "findObjektByKn",
    value: function findObjektByKn(idKn, typObjekt) {
      var uri = serverContextPath + "/api/objektByKn";
      var headers = undefined;
      var params = { idKn: idKn, typObjekt: typObjekt };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Najde id objektů podle id v ext systemu.
     *
     * @param extIds 
     * @param zdroj 
     * @return id objektu / id v ext systemu
     */

  }, {
    key: "findObjektIdByExtIds",
    value: function findObjektIdByExtIds(extIds, zdroj) {
      var uri = serverContextPath + ("/api/objektyId/extIds/" + zdroj);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, extIds, headers));
    }

    /**
     * Aktualizuje lokalni objekt.
     *
     * @param objektInput 
     * @return 
     */

  }, {
    key: "updateObjektLocal",
    value: function updateObjektLocal(objektInput) {
      var uri = serverContextPath + "/api/objekt/local";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, UpdateMethods.updateAbstractObjekt_5F61A6(objektInput), headers));
    }

    /**
     * Najde id objektu podle id z KN.
     *
     * @param idKn 
     * @param typObjekt 
     * @return 
     */

  }, {
    key: "findObjektIdByKnId",
    value: function findObjektIdByKnId(idKn, typObjekt) {
      var uri = serverContextPath + "/api/objektyIdByKn";
      var headers = undefined;
      var params = { idKn: idKn, typObjekt: typObjekt };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Najde polohu objektu v KN.
     *
     * @param idObjektList 
     * @return 
     */

  }, {
    key: "getObjektGeometry",
    value: function getObjektGeometry(idObjektList) {
      var uri = serverContextPath + "/objekt/poloha";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, idObjektList, headers));
    }

    /**
     * Načtení číselníku druhu povrchu.
     *
     * @return 
     */

  }, {
    key: "getDruhPovrchu",
    value: function getDruhPovrchu() {
      var uri = serverContextPath + "/api/objekty/druhPovrchu";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }
  }]);
  return ObjektApi;
}();

exports.default = ObjektApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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